"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryViewMode = exports.SettingsUpdatedEvent = void 0;
var SettingsUpdatedEvent;
(function (SettingsUpdatedEvent) {
    SettingsUpdatedEvent[SettingsUpdatedEvent["FREE_TEXT"] = 'free_text'] = "FREE_TEXT";
    SettingsUpdatedEvent[SettingsUpdatedEvent["LINK_CHANGED"] = 'link_changed'] = "LINK_CHANGED";
    SettingsUpdatedEvent[SettingsUpdatedEvent["ORDER_HISTORY_VIEW_MODE_CHANGED"] = 'order_history_view_mode_changed'] = "ORDER_HISTORY_VIEW_MODE_CHANGED";
})(SettingsUpdatedEvent = exports.SettingsUpdatedEvent || (exports.SettingsUpdatedEvent = {}));
var OrderHistoryViewMode;
(function (OrderHistoryViewMode) {
    OrderHistoryViewMode[OrderHistoryViewMode["DEMO"] = 'demo'] = "DEMO";
    OrderHistoryViewMode[OrderHistoryViewMode["EMPTY_STATE"] = 'empty_state'] = "EMPTY_STATE";
})(OrderHistoryViewMode = exports.OrderHistoryViewMode || (exports.OrderHistoryViewMode = {}));
//# sourceMappingURL=settings-updated-event.js.map